import { Request } from '../../../index'

import {
  SubsidyOrdersSettingsApplyResult,
  SubsidyOrdersSettingsStatusParams,
} from 'app/common/types/food/schools/subsidyOrdersSettingsApply'

type ResultDto = {
  result: 'success'
  running: boolean
}

type PathParamsDto = {
  id: string
}

export const convertParams = (
  pathParams: SubsidyOrdersSettingsStatusParams,
): [null, PathParamsDto] => {
  return [null, { id: pathParams.id }]
}

export const convertResult = (data: ResultDto): SubsidyOrdersSettingsApplyResult => {
  return { running: data.running }
}

export const GET_SCHOOL_SUBSIDY_ORDERS_SETTINGS_APPLY: Request<
  void,
  SubsidyOrdersSettingsApplyResult,
  PathParamsDto
> = ['food/schools/{id}/subsidy_orders_settings_apply', 'get', ['data']]
